import {
  Checkbox,
  Flex,
  FlexItem,
  FormElement,
  Select
} from 'mailup-web-components'
import {
  anagFiltersState,
  taskConditionsState
} from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'

const ConditionAnagFilterTrue = () => {
  const [{ AnagFilterTrue, AnagFilterTrueId }, setTaskConditionsState] =
    useRecoilState(taskConditionsState)
  const { items } = useRecoilValue(anagFiltersState)
  const intl = useIntl()

  const onChangeConditionsAnagraphicFilterTrue = () => {
    setTaskConditionsState((prev) => ({
      ...prev,
      AnagFilterTrue: !prev.AnagFilterTrue,
      isDirty: true
    }))
  }

  const onChangeAnagFilterTrueId = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      AnagFilterTrueId: val,
      isDirty: true
    }))
  }

  return (
    <>
      <Flex alignItems='flex-start'>
        <FlexItem margin='10px 0 0 0'>
          <Checkbox
            checked={AnagFilterTrue}
            onChange={onChangeConditionsAnagraphicFilterTrue}
            label={intl.formatMessage(
              { id: 'Load.Task.ConditionsAnagraphicFilterTrue' },
              {
                strong: (str) => <strong>{str}</strong>
              }
            )}
            data-mu-test='checkBox-ConditionsAnagraphicFilterTrue'
          />
        </FlexItem>
        <Flex display='block' margin='0 8px' minWidth='300px'>
          <FormElement
            feedback={
              AnagFilterTrue && !AnagFilterTrueId
                ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                : null
            }
          >
            <Select
              value={AnagFilterTrueId}
              onChange={onChangeAnagFilterTrueId}
              searchable
              placeholder={intl.formatMessage({
                id: 'Load.Task.ConditionsAnagraphicFilterPlaceholder'
              })}
              disabled={!AnagFilterTrue}
              options={items}
              error={AnagFilterTrue && !AnagFilterTrueId ? 'danger' : null}
            />
          </FormElement>
        </Flex>
      </Flex>
    </>
  )
}

export default ConditionAnagFilterTrue
